import {Component, inject} from '@angular/core';
import {AlertModalService} from '../common/component/modal/alert-modal/alert-modal.service';
import {FieldRecordLodgementErrorModalService} from '../common/component/modal/field-record-lodgement-errors-modal/field-record-lodgement-errors-modal.service';
import {FieldRecordLodgementSuccessModalService} from '../common/component/modal/field-record-lodgement-success-modal/field-record-lodgement-success-modal.service';
import {
    AttachmentsModalService,
    ConfirmationModalService,
    FirmLogoModalService,
    InformationModalService,
    LodgementSuccessModalService,
    SettingsModalService,
    UserPreferencesModalService,
    WarningModalService
} from '../common/component/modal';
import {AmendReplaceLatestModalService} from '../common/component/modal/amend-replace-latest-modal/amend-replace-latest-modal.service';
import {NlrTypeheadDirective} from '../common/directive/nlr-typehead.directive';
import {Observable, debounceTime, distinctUntilChanged, map} from 'rxjs';
import {FormsModule} from '@angular/forms';
import {SelectionType, NgxDatatableModule} from '@siemens/ngx-datatable';

@Component({
    selector: 'nlr-bootstrap-playground',
    imports: [FormsModule, NlrTypeheadDirective, NgxDatatableModule],
    templateUrl: './bootstrap-playground.component.html',
    styleUrl: './bootstrap-playground.component.scss'
})
export class BootstrapPlaygroundComponent {
    alertModalService = inject(AlertModalService);
    attachmentModalService = inject(AttachmentsModalService);
    confirmationService = inject(ConfirmationModalService);
    firmLogoModalService = inject(FirmLogoModalService);
    informationModalService = inject(InformationModalService);
    lodgementSuccessModalService = inject(LodgementSuccessModalService);
    settingsModalService = inject(SettingsModalService);
    userPreferencesModalService = inject(UserPreferencesModalService);
    warningModalService = inject(WarningModalService);
    fieldRecordLodgementErrorModalService = inject(FieldRecordLodgementErrorModalService);
    fieldRecordLodgementSuccessModalService = inject(FieldRecordLodgementSuccessModalService);
    amendModalService = inject(AmendReplaceLatestModalService);
    rows = Array.from({length: 100}, (_, i) => ({id: i + 1, name: `Item ${i + 1}`}));

    columns = [
        {prop: 'id', name: 'ID', checkboxable: true},
        {prop: 'name', name: 'Name'}
    ];

    selected: any[] = [];

    SelectionType = SelectionType;

    onSelect({selected}: any): void {
        console.log(`onSelect - selected ids:`, selected.map(attrs => attrs.id).join());
        this.selected = [...selected];
    }

    showAlertModal() {
        this.alertModalService.createAlertMessage(['Test Alert', 'Error 2', 'Error 3'], null, null, null, null, null, null, 'lg');
    }

    showAttachmentModal() {
        const extensions: string[] = ['.pdf'];
        this.attachmentModalService.showModal(extensions, 'FieldRecord', [], false, 20971520).subscribe(data => {
            console.log(data);
        });
    }
    showFieldRecordLodgementErrorModal() {
        const lodgementErrorList: string[] = ['NLRF01100: Field Record number check.'];
        this.fieldRecordLodgementErrorModalService.showModal(lodgementErrorList).subscribe(data => {
            console.log(data);
        });
    }

    showAmendReplaceLatestModal() {
        const title = 'Warning';
        const message = 'Please confirm you would like to proceed with the chosen version or use the latest version';
        this.amendModalService.showAmendReplaceLatestModal(title, message).subscribe(data => {
            console.log(data);
        });
    }

    showFieldRecordLodgementSuccessModal() {
        const title = 'Success';
        const message = 'Field record lodged successfully!';
        this.fieldRecordLodgementSuccessModalService.showModal(title, message);
    }

    showConfirmation() {
        this.confirmationService.testModal();
    }
    showFirmLogoModal() {
        this.firmLogoModalService.showModal().subscribe(data => {
            console.log(data);
        });
    }
    showInformationModal() {
        this.informationModalService.testModal();
    }
    showLodgementSuccessModal() {
        this.lodgementSuccessModalService.showModal();
    }
    showSettingsModal() {
        this.settingsModalService.testModal();
    }
    showUserPreferencesModal() {
        this.userPreferencesModalService.testModal();
    }
    showWarningModal() {
        this.warningModalService.createWarningMessage('Do you want to save the plan', 'Warning');
    }

    names = [
        'Brodie Lara',
        'Oliver Holder',
        'Brandon Ray',
        'Paige Romero',
        'Michael Pope',
        'Declan Golden',
        'Mikayla Levine',
        'Edith Lowe',
        'Olly Mcpherson',
        'Wilma Hewitt',
        'Jasper Poole',
        'Cassius Reilly',
        'Magnus Cooke',
        'Stanley Steele',
        'Lula Campbell',
        'Tiana Blanchard',
        'Lance Hanson',
        'Roger Kirby',
        'Lydia Velez',
        'Maia Sandoval',
        'Jorge Sullivan',
        'Leonie Atkins',
        'Tamara Cisneros',
        'Marvin Pruitt',
        'Amina May',
        'Carlos Blake',
        'Angus Lloyd',
        'Athena Terry',
        'Omer Kirk',
        'Kadie Booth'
    ];
    typeHeadValue = '';

    typeheadSearch: (text$: Observable<string>) => Observable<string[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => (term.length < 1 ? [] : this.names.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)))
        );
}
